import { provideHttpClient } from '@angular/common/http';
import { NgxIndexedDBModule } from 'ngx-indexed-db';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { provideRouter, Routes } from '@angular/router';
import { HomeComponent } from './app/home/home.component';
import { InviteattendeeComponent } from './app/inviteattendee/inviteattendee.component';
import { CreateneweventComponent } from './app/createnewevent/createnewevent.component';
import { InitlocaldbComponent } from './app/initlocaldb/initlocaldb.component';
import { EventsummaryComponent } from './app/eventsummary/eventsummary.component';
import { ThanksandNextStepsComponent } from './app/thanksand-next-steps/thanksand-next-steps.component';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatDividerModule } from '@angular/material/divider';
import { AppComponent } from './app/app.component';
import { importProvidersFrom } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { RootReducers } from './app/store/reducers';
import { provideNgxMask } from 'ngx-mask';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
const routes: Routes = [
  { path: 'home', component: HomeComponent, pathMatch: 'full' },
  { path: 'inviteattendee', component: InviteattendeeComponent, pathMatch: 'full' },
  { path: 'createnewevent', component: CreateneweventComponent, pathMatch: 'full' },
  { path: 'initlocaldb', component: InitlocaldbComponent, pathMatch: 'full' },
  { path: 'eventsummary', component: EventsummaryComponent, pathMatch: 'full' },
  { path: 'thanksandnextsteps', component: ThanksandNextStepsComponent, pathMatch: 'full' }
];

bootstrapApplication(AppComponent, {
    providers: [provideNgxMask(),
        importProvidersFrom(NgxIndexedDBModule.forRoot(),MatDatepickerModule, MatNativeDateModule, BrowserModule, ReactiveFormsModule, MatSelectModule, MatDividerModule, MatTableModule),
        provideHttpClient(),
        provideRouter(routes),
        provideAnimations(),
        importProvidersFrom(StoreModule.forRoot(RootReducers))
    ]
})
.catch((err) => console.error(err));
